// شاشة ترحيب تظهر مرة واحدة بعد اعتماد الحساب
import { useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Confetti } from "@/v2/components/ui";
import { PartyPopper, Rocket } from "lucide-react";

export default function WelcomeApproved() {
  const { user, refresh } = useAuth();
  const [closing, setClosing] = useState(false);
  const show = user && user.is_approved && user.welcome_seen === false;
  if (!show || closing) return null;

  const start = async () => {
    setClosing(true);
    try { await api.post("/auth/welcome-seen"); await refresh(); } catch { /* ignore */ }
  };

  return (
    <div className="v2-overlay flex items-center justify-center p-4" data-testid="welcome-overlay">
      <motion.div initial={{ scale: 0.94, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
        className="v2-glass v2-glass-gold w-full max-w-md p-8 text-center relative overflow-hidden">
        <Confetti />
        <div className="w-20 h-20 mx-auto rounded-full bg-[#bb9661]/15 text-[#e3c799] flex items-center justify-center mb-5">
          <PartyPopper size={38} />
        </div>
        <h2 className="text-2xl sm:text-3xl font-extrabold mb-3">أهلًا بك، تم اعتماد حسابك 🎉</h2>
        <p className="text-[#bcc8cf] leading-relaxed mb-2">جهزنا لك رحلة تعليمية تناسب مسارك.</p>
        <p className="text-sm v2-emerald-text font-bold mb-7">
          {user.employee_type_label} — {user.department}
        </p>
        <button onClick={start} data-testid="welcome-start" className="v2-btn w-full"><Rocket size={18} /> ابدأ رحلتي</button>
      </motion.div>
    </div>
  );
}
